import React from 'react';
import { getMobileAppParams, isMobileApp } from 'common-react';

import useStyles from './MobileAppTopBar.style';

export interface MobileAppFixedSafeBordersProps {
  backgroundColor?: string;
  zIndex?: number;
}

const MOBILE_APP_TOP_BAR_DEFAULT_ZINDEX = 9001;

export const MobileAppTopBar: React.FC<MobileAppFixedSafeBordersProps> = ({
  backgroundColor,
  zIndex = MOBILE_APP_TOP_BAR_DEFAULT_ZINDEX,
}) => {
  const safeViewTop = getMobileAppParams()?.safeViewTop ?? 0;
  const c = useStyles({
    safeViewTopHeight: safeViewTop,
    backgroundColor,
    zIndex,
  });

  if (!isMobileApp()) {
    return null;
  }

  return <div className={c.root}></div>;
};
